import { useQuery } from "@tanstack/react-query";
import { useDataProvider, useTranslate } from "ra-core";
import { useEffect, useState } from "react";
import { useWatch } from "react-hook-form";

import type { NevoraDataProvider } from "../datos/dataProvider";
import { useAbrirFicha } from "./useAbrirFicha";

/**
 * «Posible duplicado» en el alta (Robert, 09/10/2026): si ya hay negocios con un nombre
 * parecido, avisa sin bloquear. Jan y Robert ven cuáles y de quién son; un setter, solo
 * cuántos, sin decir de quién. Las señales exactas (teléfono, web, place_id, email) sí
 * bloquean, en la base. Hasta la migración 28 (14/10) la base no tiene la función y no sale nada.
 */
export const PosibleDuplicado = () => {
  const translate = useTranslate();
  const abrirFicha = useAbrirFicha();
  const dataProvider = useDataProvider<NevoraDataProvider>();
  const nombre = useWatch({ name: "nombre" }) as string | undefined;
  const [consulta, setConsulta] = useState("");

  useEffect(() => {
    const t = setTimeout(() => setConsulta((nombre ?? "").trim()), 400);
    return () => clearTimeout(t);
  }, [nombre]);

  const { data } = useQuery({
    queryKey: ["nevora", "posiblesDuplicados", consulta],
    queryFn: () => dataProvider.posiblesDuplicados(consulta),
    enabled: consulta.length >= 4,
    retry: false,
    staleTime: 60_000,
  });

  if (!data?.n) return null;
  return (
    <div
      role="status"
      data-testid="posible-duplicado"
      className="rounded-md border border-amber-600/50 bg-amber-50 px-3 py-2 text-sm text-amber-900 dark:bg-amber-950/40 dark:text-amber-200"
    >
      {data.fichas.length ? (
        <>
          <p className="font-medium">
            {translate("nevora.duplicados.aviso_admin")}
          </p>
          <ul className="mt-1 space-y-0.5">
            {data.fichas.map((f) => (
              <li key={String(f.id)}>
                <button
                  type="button"
                  className="underline underline-offset-2"
                  onClick={() => abrirFicha(f.id)}
                >
                  {f.nombre}
                </button>{" "}
                <span className="text-xs">
                  (
                  {f.dueno
                    ? translate("nevora.duplicados.de", { quien: f.dueno })
                    : translate("nevora.duplicados.sin_asignar")}
                  )
                </span>
              </li>
            ))}
          </ul>
        </>
      ) : (
        <p>
          {translate("nevora.duplicados.aviso_setter", {
            smart_count: data.n,
          })}
        </p>
      )}
    </div>
  );
};
